import { render } from "./Welcome.vue?vue&type=template&id=7051ff34&scoped=true&ts=true"
import script from "./Welcome.ts?vue&type=script&lang=ts"
export * from "./Welcome.ts?vue&type=script&lang=ts"

import "./Welcome.scss?vue&type=style&index=0&id=7051ff34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7051ff34"]])

export default __exports__